import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IMAGES } from '../../constants/images';

export const HomeGallery = () => (
  <section className="py-24 bg-white overflow-hidden" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-12"
      >
        <span className="inline-block px-4 py-2 bg-[#f1f5f9] rounded-full text-sm font-medium text-[#3b5998] mb-4">
          Recent Events
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Industry Engagements
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Engaging with industry leaders and sharing insights on government subsidies and finance.
        </p>
      </motion.div>

      <div className="relative">
        <div className="flex animate-scroll gap-6">
          {[IMAGES.event1, IMAGES.event2, IMAGES.event3, IMAGES.event4, IMAGES.event5].map((image, index) => (
            <div key={index} className="flex-shrink-0 w-80 md:w-96">
              <div className="rounded-2xl overflow-hidden shadow-lg h-64">
                <img
                  src={image}
                  alt={`Event ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
          {[IMAGES.event1, IMAGES.event2, IMAGES.event3, IMAGES.event4, IMAGES.event5].map((image, index) => (
            <div key={`dup-${index}`} className="flex-shrink-0 w-80 md:w-96">
              <div className="rounded-2xl overflow-hidden shadow-lg h-64">
                <img
                  src={image}
                  alt={`Event ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-8">
        <a
          href="https://www.instagram.com/tofin.in/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[#3b5998] font-medium hover:text-[#00bcd4] transition-colors"
        >
          Follow us on Instagram for more updates
          <ArrowRight size={18} />
        </a>
      </div>
    </div>
  </section>
);
